import { __rest } from "tslib";
import React, { useRef, useState, useEffect } from 'react';
import LxPopover from '@web-common/components/UI/LxPopover/LxPopover';
import { apiHolder as api } from 'api';
import classnames from 'classnames';
import style from './editor.module.scss';
const defaultFontSizes1 = [
    { name: '10px', value: '10px' },
    { name: '11px', value: '11px' },
    { name: '12px', value: '12px' },
    { name: '13px', value: '13px' },
    { name: '14px', value: '14px' },
    { name: '16px', value: '16px' },
    { name: '18px', value: '18px' },
    { name: '20px', value: '20px' },
    { name: '22px', value: '22px' },
    { name: '24px', value: '24px' },
    { name: '28px', value: '28px' },
    { name: '32px', value: '32px' },
    { name: '36px', value: '36px' },
    { name: '48px', value: '48px' },
];
const defaultFontSizes2 = [
    { name: '正文', value: '14px' },
    { name: '标题1', value: '28px' },
    { name: '标题2', value: '22px' },
    { name: '标题3', value: '20px' },
    { name: '标题4', value: '18px' },
];
const mapPTtoPX = {
    '6pt': '8px',
    '7pt': '9px',
    '7.5pt': '10px',
    '8pt': '11px',
    '9pt': '12px',
    '10pt': '13px',
    '10.5pt': '14px',
    '11pt': '15px',
    '12pt': '16px',
    '13pt': '17px',
    '13.5pt': '18px',
    '14pt': '19px',
    '14.5pt': '20px',
    '15pt': '21px',
    '16pt': '22px',
    '17pt': '23px',
    '18pt': '24px',
    '20pt': '26px',
    '22pt': '29px',
    '24pt': '32px',
    '26pt': '35px',
    '27pt': '36px',
    '28pt': '37px',
    '29pt': '38px',
    '30pt': '40px',
    '32pt': '42px',
    '34pt': '45px',
    '36pt': '48px',
};
const defaultFontSizes = [...defaultFontSizes1, ...defaultFontSizes2];
const storeApi = api.api.getDataStoreApi();
const HOCFontSize = (Component) => {
    const EdFontSize = (props) => {
        const { ref, onEditCreated } = props, rest = __rest(props, ["ref", "onEditCreated"]);
        const [editorInstance, seteditorInstance] = useState(null);
        const [visible, setVisible] = useState(false);
        const [selectFontSize, setSelectFontSize] = useState('');
        const [defaultFontSize, setDefaultFontSize] = useState('14px');
        const [tipPos, setTipPos] = useState({
            top: 0,
            left: 0,
        });
        const setVisibleRef = useRef(setVisible);
        const setTipPosRef = useRef(setTipPos);
        setVisibleRef.current = setVisible;
        setTipPosRef.current = setTipPos;
        const fontSizeAction = button => {
            let elem = document.querySelector('.tox-tbtn--lx-fontsize-btn');
            while (elem) {
                if (elem.className.includes('tox-toolbar__group')) {
                    break;
                }
                elem = elem.parentElement;
            }
            const elemRect = elem.getBoundingClientRect();
            setVisibleRef.current(true);
            setTipPosRef.current({
                top: elemRect.top + 40,
                left: elemRect.left,
            });
        };
        const editorSetup = ed => {
            seteditorInstance(ed);
            onEditCreated(ed);
        };
        useEffect(() => {
            if (visible && editorInstance) {
                let fontSize = editorInstance.queryCommandValue('FontSize');
                if (fontSize && fontSize.indexOf('pt') > -1 && mapPTtoPX[fontSize]) {
                    fontSize = mapPTtoPX[fontSize];
                }
                setSelectFontSize(fontSize);
            }
        }, [visible]);
        useEffect(() => {
            setDefaultFontSize(storeApi.getSync('defaultFontSize').data || '14px');
        }, []);
        const setDefaultFontSizeCl = () => {
            if (defaultFontSizes.every(i => i.value !== selectFontSize))
                return;
            storeApi.put('defaultFontSize', selectFontSize);
            setDefaultFontSize(selectFontSize);
        };
        const selectFontSizeCl = fontSize => {
            const value = fontSize.value;
            if (!editorInstance)
                return;
            setSelectFontSize(value);
            editorInstance.execCommand('FontSize', false, value);
            setVisible(false);
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(Component, Object.assign({}, rest, { ref: ref, fontSizeAction: fontSizeAction, onEditCreated: editorSetup })),
            React.createElement(LxPopover, { top: tipPos.top, left: tipPos.left, resetStyle: { zIndex: 999 }, visible: visible, setVisible: setVisible, acceptTopBottom: true },
                React.createElement("div", { className: classnames(style.fontSizeBoxWrap, style.fontCommaBoxWrap) },
                    React.createElement("div", { className: classnames(style.fontSizeBox) },
                        React.createElement("div", { className: classnames(style.column1) }, defaultFontSizes2.map(font => (React.createElement("div", { className: classnames([style.fontSizeItem]), style: { fontSize: font.value }, onClick: () => {
                                selectFontSizeCl(font);
                            } }, font.name)))),
                        React.createElement("div", { className: classnames(style.column2) }, defaultFontSizes1.map(font => (React.createElement("div", { className: classnames([style.fontSizeItem, font.value === selectFontSize && style.fontCommaSelected]), onClick: () => {
                                selectFontSizeCl(font);
                            } },
                            font.name,
                            font.value === defaultFontSize && React.createElement("span", { className: style.fontDefault }, "\u9ED8\u8BA4")))))),
                    React.createElement("div", { className: classnames(style.setDefaultCol, style.setDefaultColSticky, defaultFontSizes.every(i => i.value !== selectFontSize) && style.setDefaultDisable), onClick: setDefaultFontSizeCl }, "\u5C06\u5F53\u524D\u5B57\u53F7\u8BBE\u4E3A\u9ED8\u8BA4")))));
    };
    return React.forwardRef((props, ref) => React.createElement(EdFontSize, Object.assign({}, props, { ref: ref })));
};
export default HOCFontSize;
